import { PermissionKey } from 'constants/permissionKeys';

// The key each Home widget's data is served under; a widget renders only for admins holding it.
export const HOME_WIDGETS: Record<
  | 'clusterSummary'
  | 'recentClusters'
  | 'userSummary'
  | 'recentSignIns'
  | 'recentBackups',
  PermissionKey
> = {
  clusterSummary: 'clusters.read',
  recentClusters: 'clusters.read',
  userSummary: 'users.read',
  recentSignIns: 'users.read',
  recentBackups: 'backups.read',
};

/** Home has something to show; otherwise it hands over to the first page the admin may open. */
export const canSeeHome = (can: (key: PermissionKey) => boolean) =>
  Object.values(HOME_WIDGETS).some(can);
